import {TextField, Typography} from "@mui/material"
import Grid from "@mui/material/Grid2"
import React, {useEffect, useState} from "react"
import {useDispatch, useSelector} from "react-redux"
import {setFloorThickness} from "../../../features/floor/floorSlice"
import {ImageButton} from "./ImageButton"
import {getFloorThicknessError, isFloorThicknessValid, planLimits} from "../../../validation/form/planFormValidation"
import {
    FloorThickness15Icon,
    FloorThickness17Icon,
    FloorThickness20Icon,
    FloorThickness25Icon
} from "./FloorThicknessIcons";

const TitleGridItem = () => {
    return (
        <Grid size={12}>
            <Typography component="h1" variant="h4">
                Boden
            </Typography>
            < hr/>
        </Grid>
    )
}

const FloorThicknessField = props => {
    const {focusThicknessField, setFocusThicknessField} = props
    const dispatch = useDispatch()
    const floor = useSelector(state => state.plan.floor)
    const customFloor = !!floor && !floor.isStockFloor
    const thickness = floor ? floor.thickness : 0
    const [currentThickness, setCurrentThickness] = useState(thickness)
    const error = !floor ? null : getFloorThicknessError(currentThickness)

    useEffect(() => {
        setCurrentThickness(thickness)
    }, [thickness])

    return (
        <React.Fragment>
            <TextField
                disabled={!customFloor}
                inputRef={input => {
                    if (input != null && focusThicknessField) input.focus()
                }}
                onBlur={() => setFocusThicknessField(false)}
                onFocus={event => event.target.select()}
                type="number"
                slotProps={{
                    input: {
                        inputProps: {
                            min: planLimits.minFloorThickness,
                            max: planLimits.maxFloorThickness,
                            step: planLimits.floorThicknessStepWidth
                        }
                    }
                }}
                variant="outlined"
                fullWidth
                margin="normal"
                id="height"
                label="Bodenstärke [cm]"
                name="thickness"
                value={currentThickness}
                error={!!error}
                helperText={error}
                onChange={e => {
                    setCurrentThickness(e.target.value)
                    if (isFloorThicknessValid(e.target.value)) {
                        dispatch(setFloorThickness(parseInt(e.target.value)))
                    }
                }}
                style={{width: 207}}
            />
        </React.Fragment>
    )
}

const ThicknessGridItem = () => {
    const dispatch = useDispatch()
    const floor = useSelector(state => state.plan.floor)
    const customFloor = !!floor && !floor.isStockFloor ? floor : null;
    const [focusThicknessField, setFocusThicknessField] = useState(false);
    const [isCustomThickness, setIsCustomThickness] = useState(false);
    const floorThickness = !!floor ? floor.thickness : 0;

    return (
        <Grid size={12}>
            <Typography component="p" variant="body1" style={{marginBottom: '0.5em'}}>
                Wählen Sie die Bodenstärke aus:
            </Typography>
            <Grid container direction={'row'} justifyContent={'flex-start'} alignItems={'flex-end'} spacing={3}>
                <Grid>
                    <ImageButton
                        title={'15 cm'}
                        disabled={!customFloor}
                        checked={!isCustomThickness && floorThickness === 15}
                        onClick={() => {
                            setIsCustomThickness(false);
                            setFocusThicknessField(false)
                            dispatch(setFloorThickness(15))
                        }}
                    >
                        <FloorThickness15Icon/>
                    </ImageButton>
                </Grid>
                <Grid>
                    <ImageButton
                        title={'20 cm'}
                        disabled={!customFloor}
                        checked={!isCustomThickness && floorThickness === 20}
                        onClick={() => {
                            setIsCustomThickness(false);
                            setFocusThicknessField(false)
                            dispatch(setFloorThickness(20))
                        }}
                    >
                        <FloorThickness20Icon/>
                    </ImageButton>
                </Grid>
                <Grid>
                    <ImageButton
                        title={'25 cm'}
                        disabled={!customFloor}
                        checked={!isCustomThickness && floorThickness === 25}
                        onClick={() => {
                            setIsCustomThickness(false);
                            setFocusThicknessField(false)
                            dispatch(setFloorThickness(25))
                        }}
                    >
                        <FloorThickness25Icon/>
                    </ImageButton>
                </Grid>
                <Grid>
                    <ImageButton
                        title={'Benutzerdefiniert'}
                        disabled={!customFloor}
                        checked={
                            isCustomThickness
                            || (floorThickness !== 15 && floorThickness !== 20 && floorThickness !== 25)
                        }
                        onClick={() => {
                            setIsCustomThickness(true);
                            setFocusThicknessField(true);
                        }}
                    >
                        <FloorThickness17Icon/>
                    </ImageButton>
                </Grid>
                <Grid size={2}>
                    <FloorThicknessField
                        focusThicknessField={focusThicknessField}
                        setFocusThicknessField={setFocusThicknessField}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export const FloorSection = () => {
    return (
        <Grid container spacing={3}>
            <TitleGridItem/>
            <ThicknessGridItem/>
        </Grid>
    )
}
